import { renderGenMarkdownRendererContentComponentTemplate } from '@next-adapter/templates/renderers/generators/actions/markdown-renderer.js'
export function genMarkdownRendererContent(): string {
  return renderGenMarkdownRendererContentComponentTemplate()
}
